
import { helper } from 'helpers/appHelper';
import { resourceManager } from 'helpers/resourceManager';
import {FormTypes} from '../resources/enums';
import * as AppConstants from '../resources/constants'




// Services
//************************* */
// Simple
export function SimpleService(request, apiUrl){
    let serviceUrl = helper.getWebApiHost() + apiUrl;
    return fetch(serviceUrl, {        
        method: 'POST',
        credentials: 'include',
        headers: new Headers({
            'Accept': 'application/json; odata=verbose',
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(request)
    })
    .then((response) => {
        if (!response.ok && response.status != 405) {
            let message = `Error fatal`;
            throw Error(message);
        }
        else if(response.status ==  405){
            return response;
        }
        let ret = response.json();
        ret.error = resourceManager.getResource('ServiceMessage' + ret.errorCode)
        return ret;
    })
    .catch((error) => {
        return {errorCode: 503, error: resourceManager.getResource('ServiceMessage503') };
    })
}

// JWT
export function JWTService(request, apiUrl){
    let serviceUrl = helper.getWebApiHost() + apiUrl;
    return fetch(serviceUrl, {        
        method: 'POST',
        credentials: 'include',
        headers: new Headers({
            'Accept': 'application/json; odata=verbose',
            'Content-Type': 'application/json',
            'X-Token': request.jwtoken
        }),
        body: JSON.stringify(request.body)
    })
    .then((response) => {
        if (!response.ok && response.status != 405) {
            let message = `Error fatal`;
            throw Error(message);
        }
        else if(response.status ==  405){
            return response;
        }
        let ret = response.json();
        ret.error = resourceManager.getResource('ServiceMessage' + ret.errorCode)
        return ret;
    })
    .catch((error) => {
        return {errorCode: 503, error: resourceManager.getResource('ServiceMessage503') };
    })
}


//Validation Forms
export function validateFields(formType, formObject){
    switch(formType){
        case FormTypes.LOGIN:
            // Email, Password, Captcha & 1 or more Checks
            if(formObject.email == "" ){
                return {hasError: true, errorCode: 1}
            }
            else if(!(/^\S+@\S+\.\S+$/).test(formObject.email)){
                return {hasError: true, errorCode: 2}
            }
            else if(formObject.password == "" ){
                return {hasError: true, errorCode: 3}
            }
            else if(!formObject.captcha){
                return {hasError: true, errorCode: 5}
            }
            else{
                return {hasError: false, errorCode: 0}
            }

        case FormTypes.LOGGED:
            // 1 or more Checks
            if(formObject.subscriptions.length == 0 ){
                return {hasError: true, errorCode: 1}
            }
            else{
                return {hasError: false, errorCode: 0}
            }

        case FormTypes.RECOVERY:
            if(formObject.email == "" ){
                return {hasError: true, errorCode: 1}
            }
            else if(!(/^\S+@\S+\.\S+$/).test(formObject.email)){
                return {hasError: true, errorCode: 2}
            }
            else{
                return {hasError: false, errorCode: 0}
            }
        default:
            return {hasError: false, errorCode: 0}
    }
}

//Others
export function getCurrentVariant(){
    var path = unescape(window.location.pathname).toLowerCase();
    var variant = "";
    AppConstants.Constants.Variants.forEach(v => {
        if (path.includes(v)) {
            variant = v;
        }
    });
    if(variant == ""){
        variant = AppConstants.Constants.Keys.DefaultVariant;
    }
    return variant;
}
